var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.4678V44.4688H4V16.4678H34Z",
    fill: "#16C098",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.46875C24.4292 0.46875 28.8479 4.79542 28.9962 10.1888L29 10.4688V12.4688H36C37.0544 12.4688 37.9182 13.2846 37.9945 14.3195L38 14.4688V46.4688C38 47.5231 37.1841 48.3869 36.1493 48.4633L36 48.4688H2C0.945638 48.4688 0.0818347 47.6529 0.00548553 46.618L0 46.4688V14.4688C0 13.4144 0.815878 12.5506 1.85074 12.4742L2 12.4688H9V10.4688C9 4.9459 13.4772 0.46875 19 0.46875ZM36 14.4688H2V46.4688H36V14.4688ZM19 28.4688C20.6569 28.4688 22 29.8119 22 31.4688C22 33.1256 20.6569 34.4688 19 34.4688C17.3431 34.4688 16 33.1256 16 31.4688C16 29.8119 17.3431 28.4688 19 28.4688ZM19 30.4688C18.4477 30.4688 18 30.9165 18 31.4688C18 32.021 18.4477 32.4688 19 32.4688C19.5523 32.4688 20 32.021 20 31.4688C20 30.9165 19.5523 30.4688 19 30.4688ZM19 2.46875C14.6651 2.46875 11.1355 5.91659 11.0038 10.2196L11 10.4688V12.4688H27V10.4688C27 6.05047 23.4183 2.46875 19 2.46875Z",
    fill: "#16C098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLock);
export default __webpack_public_path__ + "static/media/greenLock.116025819ffe1c348d7d6100370808b8.svg";
export { ForwardRef as ReactComponent };